const e=({current:e})=>e?e.ownerDocument.defaultView:null;export{e as getContextWindow};
